import { fetchWithAuth } from '../auth/fetchWithAuth';
import { notifyError, notifySuccess } from '../components/Toast';

const API_REPORTES_URL = `${process.env.REACT_APP_API_BASE_URL}reportes`;

export const LoadPeis = (planId, stateId, user) => {
  return async (dispatch) => {
    dispatch({ type: 'LOAD_PEI_REQUEST' });

    const params = new URLSearchParams({
      plan: planId ?? '',
      estado: stateId ?? ''
    }).toString();

    const url = `${API_REPORTES_URL}/planes-estrategicos?${params}`;

    try {
      const res = await fetchWithAuth( url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
      },dispatch);

      if (res.ok) {
        const data = await res.json();
        dispatch({ type: 'LOAD_PEI_SUCCESS', payload: data });
        return true;
      }
      const raw = await res.text();
      dispatch({ type: 'LOAD_PEI_FAIL', payload: raw });
      notifyError(raw || 'Error al cargar planes');
      return false;

    } catch (err) {
      dispatch({ type: 'LOAD_PEI_FAIL', payload: err.message });
      notifyError('Error de conexión');
      return null;
    }
  };
};

export const SavePei = (plan, user) => {
  return async (dispatch) => {
    dispatch({ type: 'SAVE_PEI_REQUEST' });
    try {
      const res = await fetchWithAuth(`${API_REPORTES_URL}/planes-estrategicos`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
        body: JSON.stringify(plan),
      },dispatch);

      if (res.ok) {
        dispatch({ type: 'SAVE_PEI_SUCCESS' });
        dispatch(LoadPeis(null, null, user));
        notifySuccess('Plan estratégico Guardado');
        return true;
      } else {
        const msg = await res.text();
        dispatch({ type: 'SAVE_PEI_FAIL', payload: msg });
        notifyError(msg || 'Error al guardar el plan estratégico');
        return false;
      }
    } catch (err) {
      dispatch({ type: 'SAVE_PEI_FAIL', payload: err.message });
      notifyError('Error de conexión');
      return null;
    }
  };
};

export const UpdatePeiStatus = (idPei, idStatus, user) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATE_PEI_STATUS_REQUEST' });
    try {

      const resp = await fetchWithAuth(`${API_REPORTES_URL}/planes-estrategicos/${idPei}/estado/${idStatus}`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
      },dispatch );

      if (resp === null) return;

      if (!resp.ok) {
        const msg = await resp.text();
        dispatch({ type: 'UPDATE_PEI_STATUS_FAIL', payload: msg });
        notifyError(msg || 'Ocurrio un error al actualizar el plan');
        return false;
      }

      dispatch({ type: 'UPDATE_PEI_STATUS_SUCCESS' });
      dispatch(LoadPeis(null,null,user));
      notifySuccess('PLan actualizado correctamente');
      return true;

    } catch (err) {
      dispatch({ type: 'UPDATE_PEI_STATUS_FAIL', payload: err.message });
      notifyError('Error de conexión');
      return null;
    }
  };
};

export const DeletePei = (planId, user) => {
  return async (dispatch) => {
    dispatch({ type: 'DELETE_PEI_REQUEST', payload: planId });
    try {
      const res = await fetchWithAuth(`${API_REPORTES_URL}/planes-estrategicos/${planId}`,{
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
      },dispatch);

      if (res.ok) {
        dispatch({ type: 'DELETE_PEI_SUCCESS', payload: planId });
        notifySuccess('Se eliminó el plan estratégico');
        return true;

      } else {
        const msg = await res.text();
        dispatch({ type: 'DELETE_PEI_FAIL', payload: msg });
        notifyError(msg || 'Error al eliminar el plan estratégico');
        return false;
      }
    } catch (err) {
      dispatch({ type: 'DELETE_PEI_FAIL', payload: err.message });
      notifyError('Error de conexión');
      return null;
    }
  };
};

export const SavePeiObjectives = (peiId, objectives, user) => {
  return async (dispatch) => {
    dispatch({ type: 'SAVE_PEI_OBJECTIVES_REQUEST' });
    try {
      const res = await fetchWithAuth(`${API_REPORTES_URL}/planes-estrategicos/${peiId}/objetivos`,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token,
        },
        body: JSON.stringify(objectives),
      },dispatch);

      if (res.ok) {
        dispatch({ type: 'SAVE_PEI_OBJECTIVES_SUCCESS' });
        dispatch(LoadPeis(null, null, user));
        notifySuccess('Objetivos guardados correctamente');
        return true;
      } else {
        const msg = await res.text();
        dispatch({ type: 'SAVE_PEI_OBJECTIVES_FAIL', payload: msg });
        notifyError(msg || 'Ocurrio un error al guardar los objetivos');
        return false;
      }
    } catch (err) {
      dispatch({ type: 'SAVE_PEI_OBJECTIVES_FAIL', payload: err.message });
      notifyError('Error de conexión');
      return null;
    }
  };
};

export const loadMatrix = (user)  => {
  return async (dispatch) => {

    dispatch({ type: 'LOAD_MATRIX_REQUEST' });

    try {

      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/matrices`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: 'LOAD_MATRIX_SUCCESS', payload: data });
      } else {
        const errorData =  response.text();
        dispatch({ type: 'LOAD_MATRIX_FAIL', payload: errorData });
      }
        
    } catch (error) {
      dispatch({ type: 'LOAD_MATRIX_FAIL', payload: error.message });
    }
  }
};

export const loadMatrixPei = (matrixId,user)  => {
  return async (dispatch) => {

    dispatch({ type: 'LOAD_MATRIX_PEI_REQUEST' });

    try {
      const response = await fetchWithAuth(`${process.env.REACT_APP_API_BASE_URL}reportes/matrices/${matrixId}/pei`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      },dispatch);

      if (response.ok) {
        const data = await response.json();
        let pei = data?.[0] || null;

        pei?.Objetivos?.forEach((objetivo) => {
          objetivo?.criterios?.forEach((criterio) => {
            criterio?.kpiList?.forEach((kpi) => {
              kpi.numeroCompleto = `${objetivo.numObjetivo}.${criterio.numCriterio}.${kpi.numKpi}`;
            });
          });
        });

        dispatch({ type: 'LOAD_MATRIX_PEI_SUCCESS', payload: pei });
      } else {
        const errorData =  response.text();
        dispatch({ type: 'LOAD_MATRIX_PEI_FAIL', payload: errorData });
      }
        
    } catch (error) {
      notifyError('Hubo un error al obtener el PEI completo')
      dispatch({ type: 'LOAD_MATRIX_PEI_FAIL', payload: error.message });
    }
  }
};